import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap, of, Observable, forkJoin, throwError, finalize } from 'rxjs';
import { map, switchMap, concatMap, retry, catchError } from 'rxjs/operators';

import { KeycloakUser } from 'src/app/shared/keycloak-user';
import { SecurityGroups, SecurityGroupMembers, KeycloakUsersList, ReportServerUserAccess, ReportServer, JsReportUser } from 'src/app/shared/securitygroups';
import { GetglobalsettingsService } from '../services/getglobalsettings.service'
import { AuthGuard } from 'src/app/shared/auth.service'

@Injectable({
  providedIn: 'root'
})

/*
This XML file does not appear to have any style information associated with it. The document tree is shown below.
<edmx:Edmx xmlns:edmx="http://docs.oasis-open.org/odata/ns/edmx" Version="4.0">
<edmx:DataServices>
<Schema xmlns="http://docs.oasis-open.org/odata/ns/edm" Namespace="jsreport">
<EntityType Name="TemplateType">
<Property Name="name" Type="Edm.String"/>
<Property Name="content" Type="Edm.String"/>
<Property Name="recipe" Type="Edm.String"/>
<Property Name="helpers" Type="Edm.String"/>
<Property Name="engine" Type="Edm.String"/>
<Property Name="data" Type="jsreport.DataItemRefType"/>
<Property Name="localization" Type="jsreport.LocalizationType"/>
<Property Name="pdfOperations" Type="Collection(jsreport.PdfOperationType)"/>
<Property Name="pdfMeta" Type="jsreport.PdfMetaType"/>
<Property Name="pdfA" Type="jsreport.PdfAType"/>
<Property Name="pdfPassword" Type="jsreport.PdfPasswordType"/>
<Property Name="pdfSign" Type="jsreport.PdfSignTemplateType"/>
<Property Name="pdfAccessibility" Type="jsreport.PdfAccessibility"/>
<Property Name="contentType" Type="Edm.String"/>
<Property Name="fileExtension" Type="Edm.String"/>
<Property Name="contentDisposition" Type="Edm.String"/>
<Property Name="omitDataFromOutput" Type="Edm.Boolean"/>
<Property Name="chrome" Type="jsreport.ChromeType"/>
<Property Name="chromeImage" Type="jsreport.ChromeImageType"/>
<Property Name="docx" Type="jsreport.DocxType"/>
<Property Name="htmlToXlsx" Type="jsreport.HtmlToXlsxType"/>
<Property Name="pptx" Type="jsreport.PptxType"/>
<Property Name="scripts" Type="Collection(jsreport.ScriptRefType)"/>
<Property Name="staticPdf" Type="jsreport.StaticPdfTemplateType"/>
<Property Name="xlsx" Type="jsreport.XlsxRefType"/>
<Property Name="readSharingToken" Type="Edm.String"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="readPermissions" Type="Collection(Edm.String)"/>
<Property Name="editPermissions" Type="Collection(Edm.String)"/>
<Property Name="readPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="editPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="inheritedReadPermissions" Type="Collection(Edm.String)"/>
<Property Name="inheritedEditPermissions" Type="Collection(Edm.String)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="ProfileType">
<Property Name="templateShortid" Type="Edm.String"/>
<Property Name="timestamp" Type="Edm.DateTimeOffset"/>
<Property Name="finishedOn" Type="Edm.DateTimeOffset"/>
<Property Name="state" Type="Edm.String"/>
<Property Name="error" Type="Edm.String"/>
<Property Name="mode" Type="Edm.String"/>
<Property Name="blobName" Type="Edm.String"/>
<Property Name="timeout" Type="Edm.Int32"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="readPermissions" Type="Collection(Edm.String)"/>
<Property Name="editPermissions" Type="Collection(Edm.String)"/>
<Property Name="readPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="editPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="inheritedReadPermissions" Type="Collection(Edm.String)"/>
<Property Name="inheritedEditPermissions" Type="Collection(Edm.String)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="FolderType">
<Property Name="name" Type="Edm.String"/>
<Property Name="visibilityPermissions" Type="Collection(Edm.String)"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="readPermissions" Type="Collection(Edm.String)"/>
<Property Name="editPermissions" Type="Collection(Edm.String)"/>
<Property Name="readPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="editPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="inheritedReadPermissions" Type="Collection(Edm.String)"/>
<Property Name="inheritedEditPermissions" Type="Collection(Edm.String)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="SettingType">
<Property Name="key" Type="Edm.String"/>
<Property Name="value" Type="Edm.String"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="UserType">
<Property Name="username" Type="Edm.String"/>
<Property Name="name" Type="Edm.String"/>
<Property Name="password" Type="Edm.String"/>
<Property Name="isAdmin" Type="Edm.Boolean"/>
<Property Name="failedLoginAttemptsCount" Type="Edm.Int32"/>
<Property Name="failedLoginAttemptsStart" Type="Edm.DateTimeOffset"/>
<Property Name="editAllPermissions" Type="Edm.Boolean"/>
<Property Name="readAllPermissions" Type="Edm.Boolean"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="ComponentType">
<Property Name="name" Type="Edm.String"/>
<Property Name="content" Type="Edm.String"/>
<Property Name="helpers" Type="Edm.String"/>
<Property Name="engine" Type="Edm.String"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="data" Type="jsreport.DataItemRefType"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="readPermissions" Type="Collection(Edm.String)"/>
<Property Name="editPermissions" Type="Collection(Edm.String)"/>
<Property Name="readPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="editPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="inheritedReadPermissions" Type="Collection(Edm.String)"/>
<Property Name="inheritedEditPermissions" Type="Collection(Edm.String)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="DataItemType">
<Property Name="dataJson" Type="Edm.String"/>
<Property Name="name" Type="Edm.String"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="readPermissions" Type="Collection(Edm.String)"/>
<Property Name="editPermissions" Type="Collection(Edm.String)"/>
<Property Name="readPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="editPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="inheritedReadPermissions" Type="Collection(Edm.String)"/>
<Property Name="inheritedEditPermissions" Type="Collection(Edm.String)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="ReportType">
<Property Name="recipe" Type="Edm.String"/>
<Property Name="blobName" Type="Edm.String"/>
<Property Name="contentType" Type="Edm.String"/>
<Property Name="reportName" Type="Edm.String"/>
<Property Name="fileExtension" Type="Edm.String"/>
<Property Name="public" Type="Edm.Boolean"/>
<Property Name="templateShortid" Type="Edm.String"/>
<Property Name="state" Type="Edm.String"/>
<Property Name="error" Type="Edm.String"/>
<Property Name="meta" Type="Edm.String"/>
<Property Name="taskId" Type="Edm.String"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="readPermissions" Type="Collection(Edm.String)"/>
<Property Name="editPermissions" Type="Collection(Edm.String)"/>
<Property Name="readPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="editPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="inheritedReadPermissions" Type="Collection(Edm.String)"/>
<Property Name="inheritedEditPermissions" Type="Collection(Edm.String)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="TagType">
<Property Name="name" Type="Edm.String"/>
<Property Name="description" Type="Edm.String"/>
<Property Name="color" Type="Edm.String"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="readPermissions" Type="Collection(Edm.String)"/>
<Property Name="editPermissions" Type="Collection(Edm.String)"/>
<Property Name="readPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="editPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="inheritedReadPermissions" Type="Collection(Edm.String)"/>
<Property Name="inheritedEditPermissions" Type="Collection(Edm.String)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="VersionType">
<Property Name="changes" Type="Collection(jsreport.ChangeType)"/>
<Property Name="message" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="blobName" Type="Edm.String"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="AssetType">
<Property Name="name" Type="Edm.String"/>
<Property Name="content" Type="Edm.Binary"/>
<Property Name="forceUpdate" Type="Edm.Boolean"/>
<Property Name="sharedHelpersScope" Type="Edm.String"/>
<Property Name="isSharedHelper" Type="Edm.Boolean"/>
<Property Name="link" Type="Edm.String"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="pdfSign" Type="jsreport.PdfSignAssetType"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="readPermissions" Type="Collection(Edm.String)"/>
<Property Name="editPermissions" Type="Collection(Edm.String)"/>
<Property Name="readPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="editPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="inheritedReadPermissions" Type="Collection(Edm.String)"/>
<Property Name="inheritedEditPermissions" Type="Collection(Edm.String)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="UsersGroupType">
<Property Name="name" Type="Edm.String"/>
<Property Name="users" Type="Collection(jsreport.UserRefType)"/>
<Property Name="isAdmin" Type="Edm.Boolean"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="ScheduleType">
<Property Name="cron" Type="Edm.String"/>
<Property Name="name" Type="Edm.String"/>
<Property Name="templateShortid" Type="Edm.String"/>
<Property Name="nextRun" Type="Edm.DateTimeOffset"/>
<Property Name="enabled" Type="Edm.Boolean"/>
<Property Name="state" Type="Edm.String"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="TaskType">
<Property Name="scheduleShortid" Type="Edm.String"/>
<Property Name="finishDate" Type="Edm.DateTimeOffset"/>
<Property Name="state" Type="Edm.String"/>
<Property Name="error" Type="Edm.String"/>
<Property Name="ping" Type="Edm.DateTimeOffset"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityType Name="ScriptType">
<Property Name="content" Type="Edm.String"/>
<Property Name="name" Type="Edm.String"/>
<Property Name="scope" Type="Edm.String"/>
<Property Name="isGlobal" Type="Edm.Boolean"/>
<Property Name="folder" Type="jsreport.FolderRefType"/>
<Property Name="tags" Type="Collection(jsreport.TagRefType)"/>
<Property Name="readPermissions" Type="Collection(Edm.String)"/>
<Property Name="editPermissions" Type="Collection(Edm.String)"/>
<Property Name="readPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="editPermissionsGroup" Type="Collection(Edm.String)"/>
<Property Name="inheritedReadPermissions" Type="Collection(Edm.String)"/>
<Property Name="inheritedEditPermissions" Type="Collection(Edm.String)"/>
<Property Name="_id" Type="Edm.String"/>
<Property Name="creationDate" Type="Edm.DateTimeOffset"/>
<Property Name="modificationDate" Type="Edm.DateTimeOffset"/>
<Property Name="shortid" Type="Edm.String"/>
<Key>
<PropertyRef Name="_id"/>
</Key>
</EntityType>
<EntityContainer Name="Context">
<EntitySet EntityType="jsreport.TemplateType" Name="templates"/>
<EntitySet EntityType="jsreport.ProfileType" Name="profiles"/>
<EntitySet EntityType="jsreport.FolderType" Name="folders"/>
<EntitySet EntityType="jsreport.SettingType" Name="settings"/>
<EntitySet EntityType="jsreport.UserType" Name="users"/>
<EntitySet EntityType="jsreport.ComponentType" Name="components"/>
<EntitySet EntityType="jsreport.DataItemType" Name="data"/>
<EntitySet EntityType="jsreport.ReportType" Name="reports"/>
<EntitySet EntityType="jsreport.TagType" Name="tags"/>
<EntitySet EntityType="jsreport.VersionType" Name="versions"/>
<EntitySet EntityType="jsreport.AssetType" Name="assets"/>
<EntitySet EntityType="jsreport.UsersGroupType" Name="usersGroups"/>
<EntitySet EntityType="jsreport.ScheduleType" Name="schedules"/>
<EntitySet EntityType="jsreport.TaskType" Name="tasks"/>
<EntitySet EntityType="jsreport.ScriptType" Name="scripts"/>
</EntityContainer>
<ComplexType Name="FolderRefType">
<Property Name="shortid" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="DataItemRefType">
<Property Name="shortid" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="LocalizationType">
<Property Name="language" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="PdfOperationType">
<Property Name="templateShortid" Type="Edm.String"/>
<Property Name="type" Type="Edm.String"/>
<Property Name="mergeToFront" Type="Edm.Boolean"/>
<Property Name="renderForEveryPage" Type="Edm.Boolean"/>
<Property Name="mergeWholeDocument" Type="Edm.Boolean"/>
<Property Name="enabled" Type="Edm.Boolean"/>
</ComplexType>
<ComplexType Name="PdfMetaType">
<Property Name="title" Type="Edm.String"/>
<Property Name="author" Type="Edm.String"/>
<Property Name="subject" Type="Edm.String"/>
<Property Name="keywords" Type="Edm.String"/>
<Property Name="creator" Type="Edm.String"/>
<Property Name="producer" Type="Edm.String"/>
<Property Name="language" Type="Edm.String"/>
<Property Name="custom" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="PdfAType">
<Property Name="enabled" Type="Edm.Boolean"/>
</ComplexType>
<ComplexType Name="PdfAccessibility">
<Property Name="enabled" Type="Edm.Boolean"/>
<Property Name="pdfUA" Type="Edm.Boolean"/>
</ComplexType>
<ComplexType Name="PdfPasswordType">
<Property Name="password" Type="Edm.String"/>
<Property Name="ownerPassword" Type="Edm.String"/>
<Property Name="printing" Type="Edm.String"/>
<Property Name="modifying" Type="Edm.Boolean"/>
<Property Name="copying" Type="Edm.Boolean"/>
<Property Name="annotating" Type="Edm.Boolean"/>
<Property Name="fillingForms" Type="Edm.Boolean"/>
<Property Name="contentAccessibility" Type="Edm.Boolean"/>
<Property Name="documentAssembly" Type="Edm.Boolean"/>
</ComplexType>
<ComplexType Name="PdfSignTemplateType">
<Property Name="certificateAssetShortid" Type="Edm.String"/>
<Property Name="reason" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="TagRefType">
<Property Name="shortid" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="UserRefType">
<Property Name="shortid" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="ChromeType">
<Property Name="url" Type="Edm.String"/>
<Property Name="scale" Type="Edm.Decimal"/>
<Property Name="displayHeaderFooter" Type="Edm.Boolean"/>
<Property Name="printBackground" Type="Edm.Boolean"/>
<Property Name="landscape" Type="Edm.Boolean"/>
<Property Name="pageRanges" Type="Edm.String"/>
<Property Name="format" Type="Edm.String"/>
<Property Name="width" Type="Edm.String"/>
<Property Name="height" Type="Edm.String"/>
<Property Name="marginTop" Type="Edm.String"/>
<Property Name="marginRight" Type="Edm.String"/>
<Property Name="marginBottom" Type="Edm.String"/>
<Property Name="marginLeft" Type="Edm.String"/>
<Property Name="mediaType" Type="Edm.String"/>
<Property Name="viewportWidth" Type="Edm.Decimal"/>
<Property Name="viewportHeight" Type="Edm.Decimal"/>
<Property Name="waitForJS" Type="Edm.Boolean"/>
<Property Name="waitForNetworkIddle" Type="Edm.Boolean"/>
<Property Name="waitForNetworkIdle" Type="Edm.Boolean"/>
<Property Name="headerTemplate" Type="Edm.String"/>
<Property Name="footerTemplate" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="ChromeImageType">
<Property Name="url" Type="Edm.String"/>
<Property Name="type" Type="Edm.String"/>
<Property Name="quality" Type="Edm.Decimal"/>
<Property Name="fullPage" Type="Edm.Boolean"/>
<Property Name="clipX" Type="Edm.Decimal"/>
<Property Name="clipY" Type="Edm.Decimal"/>
<Property Name="clipWidth" Type="Edm.Decimal"/>
<Property Name="clipHeight" Type="Edm.Decimal"/>
<Property Name="omitBackground" Type="Edm.Boolean"/>
<Property Name="mediaType" Type="Edm.String"/>
<Property Name="viewportWidth" Type="Edm.Decimal"/>
<Property Name="viewportHeight" Type="Edm.Decimal"/>
<Property Name="waitForJS" Type="Edm.Boolean"/>
<Property Name="waitForNetworkIddle" Type="Edm.Boolean"/>
<Property Name="waitForNetworkIdle" Type="Edm.Boolean"/>
</ComplexType>
<ComplexType Name="DocxType">
<Property Name="templateAssetShortid" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="HtmlToXlsxType">
<Property Name="templateAssetShortid" Type="Edm.String"/>
<Property Name="htmlEngine" Type="Edm.String"/>
<Property Name="waitForJS" Type="Edm.Boolean"/>
</ComplexType>
<ComplexType Name="PptxType">
<Property Name="templateAssetShortid" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="ScriptRefType">
<Property Name="content" Type="Edm.String"/>
<Property Name="shortid" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="StaticPdfTemplateType">
<Property Name="pdfAssetShortid" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="XlsxRefType">
<Property Name="templateAssetShortid" Type="Edm.String"/>
</ComplexType>
<ComplexType Name="PdfSignAssetType">
<Property Name="passwordRaw" Type="Edm.String"/>
<Property Name="passwordSecure" Type="Edm.String"/>
<Property Name="passwordFilled" Type="Edm.Boolean"/>
</ComplexType>
</Schema>
</edmx:DataServices>
</edmx:Edmx>
*/

/**
 * REST client for Keycloak Admin API and jsReport OData API operations,
 * used by the user access management screen.
 *
 * **Keycloak section** (methods prefixed getObservableKeycloak*,
 * postObservableKeycloak*, etc.) calls the Keycloak Admin REST API directly
 * from the browser using the auth server URL from
 * {@link GetglobalsettingsService}. All Keycloak calls require the caller to
 * hold the can-manage-users Keycloak role, enforced by
 * {@link _getObservableApiUrl} via {@link AuthGuard}.
 *
 * **jsReport section** (methods prefixed getObservableJsReport*,
 * postObservableJsReport*, etc.) calls the jsReport OData API to manage
 * report server users, groups, and permissions.
 *
 * @remarks
 * The large XML block comment above the class declaration is the jsReport
 * OData metadata schema, kept as a developer reference for the OData endpoint
 * structure. It is not executable code.
 *
 * groupSample is a hardcoded development fixture showing the expected
 * jsReport group structure — not used in production code paths.
 *
 * The const example at the bottom of the file is a development reference
 * for the ReportServerUserAccess shape — not exported or used at runtime.
 */
export class HelperServerApiServiceService {

  groupSample =
    {
      "@odata.context": "https://auth2.disti.pro:8589/odata/$metadata#usersGroups",
      "value": [
        {
          "name": "report.admins",
          "users": [
            {
              "shortid": "uI34123"
            },
            {
              "shortid": "ZO_YvCU"
            }
          ],
          "creationDate": "2024-10-17T15:43:56.857Z",
          "modificationDate": "2025-08-01T09:28:17.612Z",
          "shortid": "rEm3gSt",
          "_id": "Zyz3yaEsuO3KqU5B",
          "isAdmin": true,
          "folder": {
            "shortid": "od2l1ml"
          }
        },
        {
          "name": "report.users",
          "users": [
            {
              "shortid": "uI34123"
            },
            {
              "shortid": "3FkNaxb"
            },
            {
              "shortid": "VbG612t"
            },
            {
              "shortid": "4xYUp__"
            },
            {
              "shortid": "ZO_YvCU"
            },
            {
              "shortid": "4fNzCLf"
            },
            {
              "shortid": "OTSoYrg"
            },
            {
              "shortid": "A_m6bYQ"
            },
            {
              "shortid": "oeuCn36"
            },
            {
              "shortid": "HDaAsdM"
            },
            {
      "shortid": "QM8o6Cj"
            },
            {
              "shortid": "Ktiqv8m"
            },
            {
              "shortid": "w_9j-GB"
            }
          ],
          "creationDate": "2024-10-17T15:43:56.857Z",
          "modificationDate": "2025-08-01T09:28:17.615Z",
          "shortid": "4h248Pb",
          "_id": "LcWaDC3Uq7Hc5jyB",
          "folder": {
            "shortid": "od2l1ml"
          }
        }
      ]
    };

  apiURL: string = '';

  httpOptions = {};

  //  // If needed, add Keycloak token to headers
  //import { KeycloakService } from 'keycloak-angular';

  //constructor(
  //  private http: HttpClient,
  //  private globalsettingsservice: GetglobalsettingsService,
  //  private keycloak: KeycloakService
  //) {
  //  // Http Options with Keycloak token
  //  this.keycloak.getToken().then(token => {
  //    this.httpOptions = {
  //      headers: new HttpHeaders({
  //        'Content-Type': 'application/json',
  //        'Authorization': 'Bearer ' + token
  //      })
  //    };
  //  });
  //}

  constructor(
    private http: HttpClient,
    private globalsettingsservice: GetglobalsettingsService,
    private authGuard: AuthGuard
  ) {
    // Http Options
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        //'Accept': 'application/json',
        //'Access-Control-Allow-Origin': '*',

      //  'Webyto-database-server': this.globalsettingsservice.getDbServerUrl(),
      //  'Webyto-database-name': this.globalsettingsservice.getDatabaseName(),
      //  'Webyto-database-user': this.globalsettingsservice.getDbUserName(),
      //  'Webyto-Main-Company': this.globalsettingsservice.getMainCompanyId().toString(),
      //  'Webyto-Main-Currency': this.globalsettingsservice.getMainCurrencyId().toString(),
      //  'Webyto-Access-Group': this.globalsettingsservice.getAccessGroup().toString(),
      //  'Webyto-TimezoneOffset': (new Date()).getTimezoneOffset().toString()
      })
    }
  }

    /**
   * Builds an absolute Keycloak Admin API URL and enforces permission guards.
   *
   * Resolves the Keycloak auth server URL from global settings, prepends it to
   * the given path, and throws an error if the current user lacks both
   * can-manage-jsreport-users and can-manage-keycloak-users roles.
   *
   * @param url - Path suffix after the auth server base URL
   *   (e.g. dmin/realms/portal/users).
   * @returns Observable emitting the absolute URL string, or erroring if the
   *   user lacks the required permissions.
   */
  private _getObservableApiUrl(url: string = ''): Observable<string> {

    return this.globalsettingsservice.getObservableLocalConnSettings().pipe(

      tap(() => {
        if (!this.authGuard.canManageJSreportUsers() || !this.authGuard.canManageKeycloakUsers())
          throw new Error('Insufficient permissions to manage Keycloak users');
      }),

      retry(1),
      catchError(this.handleError),
      map(settings => {
        let _api: string = settings.authServer && settings.authServer.url ? settings.authServer.url : this.apiURL;
        return _api + url;
      })
    );
  }

  /**
   * Calls Keycloak to get the current user information using observable API URL.
   * @returns Observable<any> with user info
   */
  getObservableKeycloakUserInfo(): Observable<any> {
    const userInfoPath = 'realms/' + this.globalsettingsservice.getKeycloakRealm() + '/protocol/openid-connect/userinfo';
    return this._getObservableApiUrl(userInfoPath).pipe(
      map(url => this.http.get<any>(url, this.httpOptions)),
      // flatten the inner observable
      // switchMap is preferred to avoid nested subscriptions
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  /**
   * Calls Keycloak to get the current user information using observable API URL.
   * @returns Observable<any> with user info
   */
  getObservable2KeycloakUserInfo(): Observable<any> {
    const userInfoPath = 'realms/' + this.globalsettingsservice.getKeycloakRealm() + '/protocol/openid-connect/userinfo';

    return this._getObservableApiUrl(userInfoPath).pipe(
      concatMap(url => this.http.get<any>(url, this.httpOptions).pipe(
        retry(1),
        catchError(this.handleError)
      )),
    );
  }

  /**
   * Returns the full list of users registered in the Keycloak realm.
   *
   * Calls GET admin/realms/{realm}/users via the Keycloak Admin API.
   * Requires can-manage-users role.
   *
   * @returns Observable emitting an array of KeycloakUser records.
   */
  getObservableKeycloakUsersList(): Observable<KeycloakUser[]> {

    const usersPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users';
    return this._getObservableApiUrl(usersPath).pipe(
      map(url => this.http.get<KeycloakUser[]>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  /**
   * Returns the count of users in the Keycloak realm (used to verify the realm
   * is reachable and populated).
   *
   * Calls GET admin/realms/{realm}/users/count via the Keycloak Admin API.
   *
   * @param uag - Security group member record (used for context; the query
   *   does not filter by this value).
   * @returns Observable emitting the count response as KeycloakUser[] shape
   *   (note: the endpoint returns a number, not an array).
   */
  checkObservableKeycloakUsersExists(uag: SecurityGroupMembers): Observable<KeycloakUser[]> {

    const usersPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/count';
    return this._getObservableApiUrl(usersPath).pipe(
      map(url => this.http.get<KeycloakUser[]>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Create Keycloak user
  // POST admin/realms/{realm}/users
  // uag.keycloakUser
  //
  // Here we need to set user ROles after creation
  // as well as user groups if needed
  // User groups are different from Security Groups and depend on Keycloak setup (????)
  // Let's say we have to set User Role 'user' to every created user
  // And Role 'admin' to some special users with Security Groups above the certain level
  //
  // Somehow we would need to get Role IDs from Keycloak first and make additional calls to set roles to user
  // But for now we will skip this step and assign only few roles from here
  // Also we have to decide about e-mail verification step
  //
  // Extract user ID from Location header after user creation


// Create Keycloak user and setup jsreport permissions
//
//this.postObservableKeycloakUser(uag).pipe(
//  concatMap(keycloakResponse => {
//    const userId = keycloakResponse.userId;
//    const email = uag.personMap.PERSONEMAIL;

//    // Assign Keycloak role
//    return this.assignRoleToUser(userId, 'user').pipe(
//      // Optionally setup jsreport permissions (if user logged in before)
//      concatMap(() => this.setupJsReportUserPermissions(email, false))
//    );
//  })
//).subscribe(
//  result => console.log('User created in Keycloak with jsreport access configured'),
//  error => console.error('Error:', error)
//);

  /**
   * Creates a new user in the Keycloak realm and returns the newly assigned
   * user ID from the Location response header.
   *
   * Calls POST admin/realms/{realm}/users. The user is created with a
   * temporary password (SecurePassword123!) that must be changed on first
   * login. Enabled by default.
   *
   * @param uag - Security group member record containing person details
   *   (personMap.PERSONEMAIL, personFirstName, personLastName).
   * @returns Observable emitting { userId, response } where userId is
   *   extracted from the Location header.
   */
  postObservableKeycloakUser(uag: SecurityGroupMembers): Observable<any> {
    environment.production || console.log('*** HelperServerApiServiceService in postObservableKeycloakUser: ' + JSON.stringify(uag));

    const newUserDetails = {
      username: uag.personMap.PERSONEMAIL,
      email: uag.personMap.PERSONEMAIL,
      firstName: uag.personMap.personFirstName,
      lastName: uag.personMap.personLastName,
      enabled: true,    // uag.keycloakLocked false = enabled (creating disabled user good from security point of view but stops the further UI flow)
      credentials: [{
        type: 'password',
        value: 'SecurePassword123!',
        temporary: true
      }]
    };

    const usersPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users';

    return this._getObservableApiUrl(usersPath).pipe(
      switchMap(url => this.http.post<any>(url, newUserDetails, {
        ...this.httpOptions,
        observe: 'response' // Get full response including headers
      })),
      map(response => {
        const location = response.headers.get('Location');
        const userId = location ? location.split('/').pop() : null;
        return { userId, response };
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  // Update Keycloak user
  // PUT admin/realms/{realm}/users/{id}
  // uag.keycloakUserId
  // uag.keycloakUser
  // uag.SGMLOGIN
  /**
   * Updates an existing Keycloak user's profile and credentials.
   *
   * Calls PUT admin/realms/{realm}/users/{SGMLOGIN}. Updates email,
   * first/last name, enabled flag, and password.
   *
   * @param uag - Security group member record with updated fields and
   *   SGMLOGIN (Keycloak user ID used as the URL path key).
   * @returns Observable emitting the Keycloak API response.
   */
  putObservableKeycloakUser(uag: SecurityGroupMembers): Observable<any> {

    const userDetails = {
      username: uag.personMap.PERSONEMAIL,
      email: uag.personMap.PERSONEMAIL,
      firstName: uag.personMap.personFirstName,
      lastName: uag.personMap.personLastName,
      enabled: uag.keycloakLocked,
      credentials: [{
        type: 'password',
        value: uag.SGMPASSWD,
        temporary: false
      }]
    };

    const userPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/' + encodeURIComponent(uag.SGMLOGIN);
    return this._getObservableApiUrl(userPath).pipe(

      map(url => this.http.put<any>(url, userDetails, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Delete Keycloak user

  /**
   * Deletes a user from the Keycloak realm by their Keycloak user ID.
   *
   * Calls DELETE admin/realms/{realm}/users/{userId}.
   *
   * @param userId - Keycloak user UUID (from the user's Keycloak profile).
   * @returns Observable emitting the Keycloak API response.
   */
  deleteKeycloakUser(userId: string): Observable<any> {
    const userPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/' + userId;
    return this._getObservableApiUrl(userPath).pipe(
      map(url => this.http.delete<any>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get all Keycloak groups
  /**
   * Returns all groups defined in the Keycloak realm.
   *
   * Calls GET admin/realms/{realm}/groups.
   *
   * @returns Observable emitting an array of Keycloak group objects.
   */
  getObservableKeycloakGroups(): Observable<any[]> {
    const groupsPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/groups';
    return this._getObservableApiUrl(groupsPath).pipe(
      map(url => this.http.get<any[]>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get specific group by ID
  /**
   * Returns a single Keycloak group by its ID.
   *
   * Calls GET admin/realms/{realm}/groups/{groupId}.
   *
   * @param groupId - Keycloak group UUID.
   * @returns Observable emitting the group object.
   */
  getObservableKeycloakGroupById(groupId: string): Observable<any> {
    const groupPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/groups/' + groupId;
    return this._getObservableApiUrl(groupPath).pipe(
      map(url => this.http.get<any>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Assign user to group
  // PUT admin/realms/{realm}/users/{user-id}/groups/{group-id}
  /**
   * Adds a Keycloak user to a group.
   *
   * Calls PUT admin/realms/{realm}/users/{userId}/groups/{groupId}.
   *
   * @param userId - Keycloak user UUID.
   * @param groupId - Keycloak group UUID.
   * @returns Observable emitting the Keycloak API response.
   */
  putObservableKeycloakUserToGroup(userId: string, groupId: string): Observable<any> {
    const userGroupPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/' + userId + '/groups/' + groupId;
    return this._getObservableApiUrl(userGroupPath).pipe(
      map(url => this.http.put<any>(url, {}, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Remove user from group
  // DELETE admin/realms/{realm}/users/{user-id}/groups/{group-id}
  /**
   * Removes a Keycloak user from a group.
   *
   * Calls DELETE admin/realms/{realm}/users/{userId}/groups/{groupId}.
   *
   * @param userId - Keycloak user UUID.
   * @param groupId - Keycloak group UUID.
   * @returns Observable emitting the Keycloak API response.
   */
  deleteObservableKeycloakUserFromGroup(userId: string, groupId: string): Observable<any> {
    const userGroupPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/' + userId + '/groups/' + groupId;
    return this._getObservableApiUrl(userGroupPath).pipe(
      map(url => this.http.delete<any>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get user's groups
  /**
   * Returns all groups that a Keycloak user belongs to.
   *
   * Calls GET admin/realms/{realm}/users/{userId}/groups.
   *
   * @param userId - Keycloak user UUID.
   * @returns Observable emitting an array of Keycloak group objects.
   */
  getObservableKeycloakUserGroups(userId: string): Observable<any[]> {
    const userGroupsPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/' + userId + '/groups';
    return this._getObservableApiUrl(userGroupsPath).pipe(
      map(url => this.http.get<any[]>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get all realm roles
  /**
   * Returns all realm-level roles defined in the Keycloak realm.
   *
   * Calls GET admin/realms/{realm}/roles.
   *
   * @returns Observable emitting an array of Keycloak role objects.
   */
  getObservableKeycloakRealmRoles(): Observable<any[]> {
    const rolesPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/roles';
    return this._getObservableApiUrl(rolesPath).pipe(
      map(url => this.http.get<any[]>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get user's realm roles (only directly assigned)
  // GET admin/realms/{realm}/users/{id}/role-mappings/realm
  /**
   * Returns the realm roles directly assigned to a Keycloak user (not
   * including roles inherited from group membership).
   *
   * Calls GET admin/realms/{realm}/users/{userId}/role-mappings/realm.
   *
   * @param userId - Keycloak user UUID.
   * @returns Observable emitting an array of directly-assigned role objects.
   */
  getObservableKeycloakUserRoles(userId: string): Observable<any[]> {
    const roleMapPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/' + userId + '/role-mappings/realm';
    return this._getObservableApiUrl(roleMapPath).pipe(
      map(url => this.http.get<any[]>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get user's EFFECTIVE realm roles (including roles from group membership)
  // GET admin/realms/{realm}/users/{id}/role-mappings/realm/composite
  /**
   * Returns all effective realm roles for a Keycloak user, including roles
   * inherited from group membership.
   *
   * Calls GET admin/realms/{realm}/users/{userId}/role-mappings/realm/composite.
   *
   * @param userId - Keycloak user UUID.
   * @returns Observable emitting all effective realm role objects.
   */
  getObservableKeycloakUserEffectiveRoles(userId: string): Observable<any[]> {
    const roleMapPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/' + userId + '/role-mappings/realm/composite';
    return this._getObservableApiUrl(roleMapPath).pipe(
      map(url => this.http.get<any[]>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get ALL effective roles (realm + client roles, including from groups)
  // This is the most comprehensive method
  /**
   * Returns all effective roles for a Keycloak user including both realm
   * roles and client roles, from direct assignment and group membership.
   *
   * Calls GET admin/realms/{realm}/users/{userId}/role-mappings.
   *
   * @param userId - Keycloak user UUID.
   * @returns Observable emitting the full role-mappings object.
   */
  getObservableKeycloakUserAllEffectiveRoles(userId: string): Observable<any> {
    const roleMapPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/' + userId + '/role-mappings';
    return this._getObservableApiUrl(roleMapPath).pipe(
      map(url => this.http.get<any>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get specific role by name
  /**
   * Returns a single Keycloak realm role by its name.
   *
   * Calls GET admin/realms/{realm}/roles/{roleName}. Used by
   * {@link assignRoleToUser} to resolve the role object (including its ID)
   * before assigning it.
   *
   * @param roleName - Keycloak realm role name (e.g. 'portal-user').
   * @returns Observable emitting the role object with id and 
ame.
   */
  getObservableKeycloakRoleByName(roleName: string): Observable<any> {
    const rolePath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/roles/' + encodeURIComponent(roleName);
    return this._getObservableApiUrl(rolePath).pipe(
      map(url => this.http.get<any>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Assign realm roles to user
  // POST admin/realms/{realm}/users/{id}/role-mappings/realm
  // Body: array of role representations [{ id: 'role-id', name: 'role-name' }]
  /**
   * Assigns one or more realm roles to a Keycloak user.
   *
   * Calls POST admin/realms/{realm}/users/{userId}/role-mappings/realm.
   * The body must be an array of role representation objects with id and
   * 
ame fields (use {@link getObservableKeycloakRoleByName} to resolve
   * role objects from names).
   *
   * @param userId - Keycloak user UUID.
   * @param roles - Array of role objects [{ id: string, name: string }].
   * @returns Observable emitting the Keycloak API response.
   */
  postObservableKeycloakUserRoles(userId: string, roles: any[]): Observable<any> {
    const roleMapPath = 'admin/realms/' + this.globalsettingsservice.getKeycloakRealm() + '/users/' + userId + '/role-mappings/realm';
    return this._getObservableApiUrl(roleMapPath).pipe(
      map(url => this.http.post<any>(url, roles, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }


  // Helper method to assign a single role by name to a user
  /**
   * Assigns a single realm role to a Keycloak user by role name.
   *
   * Resolves the role object via {@link getObservableKeycloakRoleByName} and
   * then assigns it via {@link postObservableKeycloakUserRoles} in a
   * sequential pipeline.
   *
   * @param userId - Keycloak user UUID.
   * @param roleName - Keycloak realm role name (e.g. 'portal-user').
   * @returns Observable completing when the role assignment is confirmed.
   */
  assignRoleToUser(userId: string, roleName: string): Observable<any> {
    return this.getObservableKeycloakRoleByName(roleName).pipe(
      concatMap(role => this.postObservableKeycloakUserRoles(userId, [role]))
    );
  }

  // Helper method to check if user has a specific role (including from groups)
  /**
   * Checks whether a Keycloak user holds a specific effective realm role
   * (including roles from group membership).
   *
   * @param userId - Keycloak user UUID.
   * @param roleName - Role name to check for.
   * @returns Observable emitting 	rue if the user holds the role, alse
   *   otherwise (including on API error).
   */
  userHasRole(userId: string, roleName: string): Observable<boolean> {
    return this.getObservableKeycloakUserEffectiveRoles(userId).pipe(
      map(roles => roles.some(role => role.name === roleName)),
      catchError(() => of(false))
    );
  }

  // Helper method to check if user has ANY of the required roles
  /**
   * Checks whether a Keycloak user holds at least one of the specified
   * effective realm roles.
   *
   * @param userId - Keycloak user UUID.
   * @param roleNames - Array of role names to check against.
   * @returns Observable emitting 	rue if the user holds any of the roles,
   *   alse otherwise (including on API error).
   */
  userHasAnyRole(userId: string, roleNames: string[]): Observable<boolean> {
    return this.getObservableKeycloakUserEffectiveRoles(userId).pipe(
      map(roles => {
        const userRoleNames = roles.map(r => r.name);
        return roleNames.some(roleName => userRoleNames.includes(roleName));
      }),
      catchError(() => of(false))
    );
  }

  // Helper method to check if user has ALL required roles
  /**
   * Checks whether a Keycloak user holds all of the specified effective realm
   * roles.
   *
   * @param userId - Keycloak user UUID.
   * @param roleNames - Array of role names, all of which must be held.
   * @returns Observable emitting 	rue if the user holds every role, alse
   *   otherwise (including on API error).
   */
  userHasAllRoles(userId: string, roleNames: string[]): Observable<boolean> {
    return this.getObservableKeycloakUserEffectiveRoles(userId).pipe(
      map(roles => {
        const userRoleNames = roles.map(r => r.name);
        return roleNames.every(roleName => userRoleNames.includes(roleName));
      }),
      catchError(() => of(false))
    );
  }

  // Get jsreport server URL from global settings
  /**
   * Placeholder for jsReport server URL resolution.
   *
   * Currently returns the given path unchanged (of(path)). The full
   * implementation (reading from global settings) is commented out and awaits
   * a settings migration. Do not rely on this method resolving a real server
   * URL until the implementation is restored.
   *
   * @param path - Full jsReport API URL (caller must supply the complete URL).
   * @returns Observable emitting the path unchanged.
   */
  private _getObservableJsReportUrl(path: string = ''): Observable<string> {
    return of(path);  // Placeholder implementation

  //  return this.globalsettingsservice.getObservableConnSettings().pipe(
  //    retry(1),
  //    catchError(this.handleError),
  //    map(settings => {
  //      let reportUrl: string = settings.reportServer && settings.reportServer.url1
  //        ? settings.reportServer.url1
  //        : this.globalsettingsservice.getReportServerUrl();
  //      return reportUrl + path;
  //    })
  //  );
  }

  // Get jsreport user profile (uses Keycloak token automatically)
  // GET /odata/users/me
  /**
   * Returns the current user's jsReport profile from a specific report server.
   *
   * Calls GET {rsUrl}/odata/users/me. The authenticated user is identified
   * by the session/token sent in the request headers.
   *
   * @param rsUrl - Base URL of the jsReport server instance
   *   (e.g. https://report1.disti.pro:5589).
   * @returns Observable emitting the jsReport user profile object.
   */
  getObservableJsReportCurrentUser(rsUrl: string): Observable<any> {
    return this._getObservableJsReportUrl(rsUrl + '/odata/users/me').pipe(
      map(url => this.http.get<any>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get all jsreport users
  // GET /api/users
  /**
   * Returns all users registered in a jsReport server instance.
   *
   * Calls GET {rsUrl}/odata/users.
   *
   * @param rsUrl - Base URL of the jsReport server instance.
   * @returns Observable emitting the jsReport OData users collection.
   */
  getObservableJsReportUsers(rsUrl: string): Observable<any> {
    return this._getObservableJsReportUrl(rsUrl + '/odata/users').pipe(
      map(url => this.http.get<any>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Update jsreport user permissions/settings
  // PATCH /odata/users(shortid) <- looks like we have to use _id here
  // By observation on studio api calls
  // Note: With Keycloak auth, user identity comes from Keycloak,
  // but you can update jsreport-specific settings like permissions, folders access, etc.

  /**
   * Updates jsReport-specific settings for an existing user (permissions,
   * folders access, etc.) via the OData PATCH endpoint.
   *
   * Calls PATCH {rsUrl}/odata/users({user._id}).
   *
   * @param rsUrl - Report server access descriptor including the server URL.
   * @param user - The jsReport user record whose _id is used as the path key.
   * @param settings - Partial settings object to merge (e.g.
   *   { readAllPermissions: true, editAllPermissions: false }).
   * @returns Observable emitting the updated jsReport user object.
   */
  putObservableJsReportUserSettings(rsUrl: ReportServerUserAccess, user: JsReportUser, settings: any): Observable<any> {
    return this._getObservableJsReportUrl(rsUrl.serverUrl + "/odata/users(" + user._id + ")").pipe(
      map(url => this.http.patch<any>(url, settings, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Get jsreport user by username (email from Keycloak)
  // GET /api/users?username={username}
  /**
   * Searches for a jsReport user by their username (email address from
   * Keycloak) using the OData filter syntax.
   *
   * Calls GET {rsUrl}/odata/users?=username eq '{username}'.
   *
   * @param rsUrl - Report server access descriptor.
   * @param username - Keycloak email/username to search for.
   * @returns Observable emitting an array of matching JsReportUser records
   *   (typically zero or one element).
   */
  getObservableJsReportUserByUsername(rsUrl: ReportServerUserAccess, username: string): Observable<JsReportUser[]> {
    environment.production || console.log('*** HelperServerApiServiceService in getObservableJsReportUserByUsername: looking for: ' + username + ' in ' + rsUrl.serverUrl);
    //environment.production || console.log('*** HelperServerApiServiceService in getObservableJsReportUserByUsername: ' + JSON.stringify(rsUrl));

    return this._getObservableJsReportUrl(rsUrl.serverUrl + '/odata/users?$filter=' + encodeURIComponent("username eq '" + String(username).replace(/'/g, "''") + "'")).pipe(
      switchMap(url => this.http.get<any>(url, this.httpOptions)),
      map(response => response.value || []),
      retry(1),
      catchError(this.handleError)
    );
  }

  // Create jsreport user (before first login) and place in user directory
  // POST /odata/users
  /**
   * Creates a new jsReport user record, or returns the existing one if the
   * user is already found in sUrl.reportServerInstance.users.
   *
   * Calls POST {rsUrl}/odata/users when the user does not yet exist.
   * Short-circuits with of(existingUser) when found in the cached instance
   * to avoid duplicate creation.
   *
   * @param rsUrl - Report server access descriptor including the cached user
   *   list in eportServerInstance.users.
   * @param userDetails - The JsReportUser record to create.
   * @returns Observable emitting the created or existing user object.
   */
  postObservableJsReportUser(rsUrl: ReportServerUserAccess, userDetails: JsReportUser): Observable<any> {
    // Alternative method to check if user exists and create if not
    // Search in reportServerInstance first (users)
    if (!rsUrl) {
      return throwError(() => new Error('Report server URL is not defined'));
    }
    environment.production || console.log('*** HelperServerApiServiceService in postObservableJsReportUser: ' + JSON.stringify(userDetails));

    const reportUser = rsUrl.reportServerInstance.users?.find(u => u.userName?.toLowerCase() === userDetails.name?.toLowerCase());

    environment.production || console.log('*** HelperServerApiServiceService in reportUser found: ' + JSON.stringify(reportUser));

    return reportUser ? of(reportUser) : this._getObservableJsReportUrl(rsUrl.serverUrl + '/odata/users').pipe(
      switchMap(url => this.http.post<any>(url, userDetails, this.httpOptions)),
            retry(1),
            catchError(this.handleError)
    );
  }

  // Helper method to get or create user directory folder
  /**
   * Returns the jsReport folder with the given name, creating it if it does
   * not yet exist.
   *
   * Calls GET {rsUrl}/odata/folders?=name eq '{folderName}' first;
   * if not found, calls POST {rsUrl}/odata/folders to create it.
   *
   * @param rsUrl - Report server access descriptor.
   * @param folderName - Folder name to find or create. Defaults to 'users'.
   * @returns Observable emitting the folder object (existing or newly created).
   */
  getOrCreateUserFolder(rsUrl: ReportServerUserAccess, folderName: string = 'users'): Observable<any> {
    return this._getObservableJsReportUrl(rsUrl.serverUrl + '/odata/folders?$filter=' + encodeURIComponent("name eq '" + String(folderName).replace(/'/g, "''") + "'")).pipe(
      switchMap(url => this.http.get<any>(url, this.httpOptions)),
      concatMap(response => {
        if (response.value && response.value.length > 0) {
          // Folder exists
          return of(response.value[0]);
        } else {
          // Create folder
          const folderData = { name: folderName };
          return this._getObservableJsReportUrl(rsUrl.serverUrl + '/odata/folders').pipe(
            switchMap(url => this.http.post<any>(url, folderData, this.httpOptions))
          );
        }
      }),
      retry(1),
      catchError(this.handleError)
    );
  }

  // Delete jsreport user settings (not the Keycloak user)
  // DELETE /odata/users(shortid)
  /**
   * Deletes a jsReport user record from the report server.
   *
   * Calls DELETE {rsUrl}/odata/users({user._id}). This removes the jsReport
   * identity only — it does NOT delete the corresponding Keycloak user.
   *
   * @param rsUrl - Report server access descriptor.
   * @param user - The jsReport user to delete. _id must be set.
   * @returns Observable emitting the jsReport API response.
   */
  deleteObservableJsReportUser(rsUrl: ReportServerUserAccess, user: JsReportUser): Observable<any> {
    return this._getObservableJsReportUrl(rsUrl.serverUrl + "/odata/users(" + user._id + ")").pipe(
      map(url => this.http.delete<any>(url, this.httpOptions)),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Helper method to setup jsreport permissions after Keycloak user creation
  // This checks if user exists in jsreport and sets up initial permissions

  /**
   * Ensures a jsReport user exists and has the correct permissions on a
   * specific report server instance.
   *
   * If the user already exists (found via
   * {@link getObservableJsReportUserByUsername}): updates eadAllPermissions
   * and editAllPermissions via {@link putObservableJsReportUserSettings}.
   *
   * If the user does not exist: creates the user via
   * {@link getOrCreateUserFolder} + {@link postObservableJsReportUser} with
   * the permissions from server.readAccess / server.editAccess.
   *
   * @param server - Report server access descriptor containing the target
   *   username (userName), desired permissions, and the server URL.
   * @returns Observable emitting the server descriptor after permissions are
   *   applied, or erroring if the Keycloak user was not yet created.
   */
  setupJsReportUserPermissions(server: ReportServerUserAccess): Observable<ReportServerUserAccess> {
    environment.production || console.log('*** HelperServerApiServiceService in setupJsReportUserPermissions: ' + JSON.stringify(server));

    // here we come with server info including userName (email) and desired permissions
    // plus groups info in server.groups wich is array of groups user should belong to
    // if user not belongs to any group - server.groups is empty array

    // but also there is reportserver array on caller side where all groups with belonging users listed
    // User's belonging to groups is the property of groups not user itself
    // Therefore we need to check user's belonging to groups and setup jsreport user groups accordingly
    // by walking throgh all groups and checking if user is member of the group and making necessary calls
    // to add user to group if needed or contrary remove user from group if not member anymore

    // To solve this task we have introdused user.reportServerInstance field of type ReportServer to find actual information about groups

    // First we need to check if user exists in jsreport already
    // and if user exists we need to update permissions
    // otherwise we need to create user first and than set permissions

    return this.getObservableJsReportUserByUsername(server, server.userName).pipe(
      tap(users => environment.production || console.log('*** HelperServerApiServiceService jsreport server "' + server.serverUrl + '" users found: ' + JSON.stringify(users))),
      concatMap(users => {
        if (users?.length > 0) {
          // User already exists in jsreport (logged in before)
          const user = users[0];
          const settings = {
          //  name: user.name,
          //  shortid: user.shortid,
            readAllPermissions: server.readAccess,
            editAllPermissions: server.editAccess,
            //  isAdmin: server.isAdmin
            // Looks like isAdmin cannot be changed this way - needs more investigation
          };

          // try to add user assigned groups into server.groups
          // Very aproximate logic - needs more testing
          // there is no settings for groups
          // rather patch the groups array directly and add/remove user from groups

          // groups info stored into server.groups
          // We need to add user to these groups
          // and remove from groups where user not assigned anymore
          // and than call patch to update particular group

          // At least so stated in JSreport api docs and examples
          // https://jsreport.net/learn/api#section/Users-groups-and-permissions

          // Very rough logic to update groups info - remove from all groups first
          // and than add to groups where user assigned
          // but it should be done on other method - setupJsReportUserGroups
          // called somewhere in putObservableJsReportUserSettings

          // and we have another issue - report server still doesn't reflects readAllPermissions/editAllPermissions settings properly

          return this.putObservableJsReportUserSettings(server, user, settings).pipe(
            map(() => server),
            tap(server => environment.production || console.log('*** HelperServerApiServiceService in setupJsReportUserPermissions: return (1) ' + JSON.stringify(server))),
          );
        } else {
          // User doesn't exist - needs to be created
          // Check if we can create user (keycloak user should exist first)
          if (!server.kcLogin || server.kcLogin === '') {
            return throwError(() => new Error('Cannot create jsreport user: Keycloak user not created'));
          }

          // Get/create user folder first, then create user
          return this.getOrCreateUserFolder(server, 'users').pipe(
            tap(folder => environment.production || console.log('*** HelperServerApiServiceService jsreport server "' + server.serverUrl + '" user folder: ' + JSON.stringify(folder))),
            concatMap(folder => {
              const userDetails: JsReportUser = {
                username: server.userName,
                password: server.password || 'TemporaryPassword123!',
                name: server.userName,
                folder: { shortid: folder.shortid },
                readAllPermissions: server.readAccess,
                editAllPermissions: server.editAccess,
                isAdmin: server.isAdmin
              };

              return this.postObservableJsReportUser(server, userDetails).pipe(
              //  concatMap(createdUser => {
              //    // Set permissions for newly created user
              //    const settings = {
              //      shortid: createdUser.shortid,
              //      readAllPermissions: server.readAccess,
              //      editAllPermissions: server.editAccess,
              //      isAdmin: server.isAdmin,
              //      folder: { shortid: folder.shortid },
              //    };

              //    return this.putObservableJsReportUserSettings(server, createdUser, settings).pipe(
              //      map(() => server),
              //      tap(server => environment.production || console.log('*** HelperServerApiServiceService in setupJsReportUserPermissions: return (2) ' + JSON.stringify(server))),
              //    );
              //  })
              );
            })
          );
        }
      }),
      catchError(error => {
        console.error('*** HelperServerApiServiceService in setupJsReportUserPermissions: Error: ' + error);
        return throwError(() => error);
      })
    );
  }

  // Here we need to check user's belonging to groups and setup jsreport user groups accordingly
  // Another task to remove user from groups if needed

  // Acording to jsreport api docs we need to call PATCH /odata/groups({shortid}) with body containing updated group info
  // including users array with user shortids
  // https://jsreport.net/learn/api#section/Users-groups-and-permissions
  // But we don't have shortid of user at this point
  // But we have fully populated group objects in reportServerInstance.groups
  // So we have to 1) remove user from groups where not assigned anymore and 2) add user to groups where assigned

  /**
   * Synchronises a jsReport user's group membership with the desired group
   * assignments in server.groups.
   *
   * For each group in server.reportServerInstance.groups:
   * - If the user should be a member but is not: adds them via
   *   PATCH /odata/usersGroups({group._id}).
   * - If the user should not be a member but is: removes them.
   * - If no change is needed: skips.
   *
   * @param server - Report server access descriptor with userName, desired
   *   groups array, and eportServerInstance (full group+user snapshot).
   * @returns Observable emitting the server descriptor after group sync
   *   completes, or of(server) immediately if no instance data is available.
   */
  setupJsReportUserGroups(server: ReportServerUserAccess): Observable<ReportServerUserAccess> {
    environment.production || console.log('*** HelperServerApiServiceService in setupJsReportUserGroups: ' + JSON.stringify(server));

    if (!server.reportServerInstance) {
      return of(server);
    }

    const userName = server.userName;
    return this.getObservableJsReportUserByUsername(server, userName).pipe(
      concatMap(users => {
        if (users.length === 0) {
          return throwError(() => new Error('User not found in jsreport: ' + userName));
        }
        const user = users[0];
        const userShortId = user.shortid;
        const groupUpdates$ = server.reportServerInstance.groups?.map(group => {
          const isMember = server.groups?.some(g => g.name === group.name);
          const userInGroup = group.users?.some(u => u.shortid === userShortId);
          let updatedUsers = group.users || [];

          if (isMember && !userInGroup) {
            // Add user to group
            updatedUsers = [...updatedUsers, { shortid: userShortId }];
          } else if (!isMember && userInGroup) {
            // Remove user from group
            updatedUsers = updatedUsers.filter(u => u.shortid !== userShortId);
          } else {
            // No change needed
            return of(null);
          }

          const groupUpdate = {
            name: group.name,
            users: updatedUsers,
            creationDate: group.creationDate,
            modificationDate: new Date().toISOString(),
            shortid: group.shortid,
            folder: group.folder
          };

          return this._getObservableJsReportUrl(server.serverUrl + "/odata/usersGroups(" + group._id + ")").pipe(
            switchMap(url => this.http.patch<any>(url, groupUpdate, this.httpOptions)),
            retry(1),
            catchError(this.handleError)
          );
        });
        return groupUpdates$.length > 0 ? forkJoin(groupUpdates$).pipe(map(() => server)) : of(server);
      }),
      catchError(error => {
        console.error('*** HelperServerApiServiceService in setupJsReportUserGroups: Error: ' + error);
        return throwError(() => error);
      })
    );
  }

  // Get jsreport user groups
  /**
   * Returns all user groups defined in a jsReport server instance.
   *
   * Calls GET {rsUrl}/odata/usersGroups. Used to populate the group
   * snapshot in eportServerInstance.groups.
   *
   * @param rsUrl - Report server descriptor with serverUrl.
   * @returns Observable emitting the jsReport OData groups collection.
   */
  getJsReportServerUserGroups(rsUrl: ReportServer): Observable<any> {
    return this._getObservableJsReportUrl(rsUrl.serverUrl + "/odata/usersGroups").pipe(
      map(url => this.http.get<any>(url, this.httpOptions).pipe(
        tap(groupsInfo => environment.production || console.log('*** HelperServerApiServiceService jsreport server "' + url + '" groupsInfo: ' + JSON.stringify(groupsInfo)))
      )),
      switchMap(request$ => request$.pipe(
        retry(1),
        catchError(this.handleError)
      ))
    );
  }

  // Error handling
  /**
   * Centralised HTTP error handler used by all methods in this service.
   *
   * Extracts a human-readable message, shows a browser lert (legacy pattern
   * — Phase 1 will replace with a toast), and re-throws so the calling
   * Observable terminates.
   *
   * @param error - Angular HttpErrorResponse or ErrorEvent.
   * @returns An Observable that immediately errors with the formatted message.
   */
  handleError(error): Observable<never> {
    let errorMessage = '';
    
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    window.alert(errorMessage);
    return throwError(() => errorMessage);
  }
}

const example: ReportServerUserAccess = {
  serverName: 'report1',
  serverUrl: 'https://dupa.disti.pro:5589',
  userName: 'ap@proxis.ua',
  kcLogin: 'ap@proxis.ua',
  readAccess: true,
  editAccess: false,
  isAdmin: false,
  userId: 'Q4LCTyhAtCY10EpA',
  shortId: 'GnFs7QE',
  enabled: true,
  groups: [
    {
      name: 'report.users',
      users: [
        { shortid: 'uI34123' },
        { shortid: '3FkNaxb' },
        { shortid: 'VbG612t' },
        { shortid: '4xYUp__' },
        { shortid: 'ZO_YvCU' },
        { shortid: '4fNzCLf' },
        { shortid: 'OTSoYrg' },
        { shortid: 'A_m6bYQ' },
        { shortid: 'oeuCn36' },
        { shortid: 'HDaAsdM' },
        { shortid: 'QM8o6Cj' },
        { shortid: 'Ktiqv8m' },
        { shortid: 'w_9j-GB' }
      ],
      creationDate: '2024-10-17T15:43:56.857Z',
      modificationDate: '2025-08-01T09:28:17.615Z',
      shortid: '4h248Pb',
      _id: 'LcWaDC3Uq7Hc5jyB',
      folder: { shortid: 'od2l1ml' }
    }
  ],
  reportServerInstance: {
    serverName: 'report1',
    serverUrl: 'https://dupa.disti.pro:5589',
    users: [
      {
        name: 'denism@disti.pro',
        username: 'denism@disti.pro',
        creationDate: '2024-03-08T10:24:30.111Z',
        modificationDate: '2024-03-08T10:31:56.587Z',
        shortid: 'syEP7Fs',
        _id: 'URrJsVwDrBwQRXpe',
        readAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'maximm@disti.pro',
        username: 'maximm@disti.pro',
        creationDate: '2024-01-02T07:51:46.299Z',
        modificationDate: '2024-01-09T10:42:41.013Z',
        shortid: '4xYUp__',
        _id: 'LfrAgOW7kIJA9rxM',
        readAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'oleksans@disti.pro',
        username: 'oleksans@disti.pro',
        creationDate: '2024-01-02T07:54:22.839Z',
        modificationDate: '2026-01-08T14:56:49.138Z',
        shortid: '4fNzCLf',
        _id: 'eRviwyE10iD3rG6z',
        readAllPermissions: true,
        folder: { shortid: 'UIedmPH' },
        editAllPermissions: false
      },
      {
        username: 'ap@proxis.ua',
        name: 'ap@proxis.ua',
        readAllPermissions: true,
        editAllPermissions: false,
        creationDate: '2026-01-05T18:32:02.451Z',
        modificationDate: '2026-01-08T14:33:35.910Z',
        shortid: 'GnFs7QE',
        _id: 'Q4LCTyhAtCY10EpA',
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'miroslavn@disti.pro',
        username: 'miroslavn@disti.pro',
        creationDate: '2024-01-02T07:52:07.407Z',
        modificationDate: '2026-01-06T09:14:28.985Z',
        shortid: 'ZO_YvCU',
        _id: 'HcsJDXs7cB1xEEvB',
        readAllPermissions: true,
        isAdmin: true,
        editAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'book447741@gmail.com',
        username: 'book447741@gmail.com',
        creationDate: '2025-06-25T15:06:50.020Z',
        modificationDate: '2026-01-05T18:32:42.516Z',
        shortid: 'U7PuXMG',
        _id: 'j1UaslVTIhQFWQle',
        readAllPermissions: true,
        editAllPermissions: false,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'oleksiis@disti.pro',
        username: 'oleksiis@disti.pro',
        creationDate: '2024-01-02T07:54:47.974Z',
        modificationDate: '2024-01-09T10:42:41.032Z',
        shortid: 'OTSoYrg',
        _id: 'kVYIIWehbL2PB8iT',
        readAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'reginag@disti.pro',
        username: 'reginag@disti.pro',
        creationDate: '2025-08-01T09:28:17.606Z',
        modificationDate: '2025-08-01T09:28:17.606Z',
        shortid: 'w_9j-GB',
        _id: 'f1OZt1cghTCCW9Uu',
        readAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'sergiik@disti.pro',
        username: 'sergiik@disti.pro',
        creationDate: '2024-01-02T07:21:44.051Z',
        modificationDate: '2026-01-06T09:14:08.657Z',
        shortid: 'uI34123',
        _id: 'uHM9PHGN3NvbRpEh',
        isAdmin: true,
        readAllPermissions: true,
        editAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'sergiik@proxis.ua',
        username: 'sergiik@proxis.ua',
        creationDate: '2024-01-02T07:22:22.690Z',
        modificationDate: '2024-01-09T10:42:41.044Z',
        shortid: '3FkNaxb',
        _id: 'H4Vzflwj91A5i1iC',
        isAdmin: false,
        readAllPermissions: true,
        editAllPermissions: false,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'sergiil@disti.pro',
        username: 'sergiil@disti.pro',
        creationDate: '2024-01-02T07:55:08.260Z',
        modificationDate: '2026-01-06T09:13:49.934Z',
        shortid: 'A_m6bYQ',
        _id: 'AiT6EdEmv3zqgiyh',
        readAllPermissions: true,
        editAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'sergiis@disti.pro',
        username: 'sergiis@disti.pro',
        creationDate: '2024-01-02T07:36:44.195Z',
        modificationDate: '2024-01-09T10:42:41.006Z',
        shortid: 'VbG612t',
        _id: 'YnpPxX4YLItzrh0Y',
        readAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'tanyas@disti.pro',
        username: 'tanyas@disti.pro',
        creationDate: '2024-01-02T07:55:54.829Z',
        modificationDate: '2024-01-09T10:42:41.063Z',
        shortid: 'oeuCn36',
        _id: 'vlb7qEtoX6GjyYj1',
        readAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      },
      {
        name: 'vm@disti.pro',
        username: 'vm@disti.pro',
        creationDate: '2024-01-02T07:55:34.596Z',
        modificationDate: '2024-01-09T10:42:41.065Z',
        shortid: 'HDaAsdM',
        _id: 'uAfihbLQVoHXTw4o',
        readAllPermissions: true,
        folder: { shortid: 'UIedmPH' }
      }
    ],
    groups: [
      {
        name: 'report.users',
        users: [
          { shortid: 'uI34123' },
          { shortid: '3FkNaxb' },
          { shortid: 'VbG612t' },
          { shortid: '4xYUp__' },
          { shortid: 'ZO_YvCU' },
          { shortid: '4fNzCLf' },
          { shortid: 'OTSoYrg' },
          { shortid: 'A_m6bYQ' },
          { shortid: 'oeuCn36' },
          { shortid: 'HDaAsdM' },
          { shortid: 'QM8o6Cj' },
          { shortid: 'Ktiqv8m' },
          { shortid: 'w_9j-GB' }
        ],
        creationDate: '2024-10-17T15:43:56.857Z',
        modificationDate: '2025-08-01T09:28:17.615Z',
        shortid: '4h248Pb',
        _id: 'LcWaDC3Uq7Hc5jyB',
        folder: { shortid: 'od2l1ml' }
      },
      {
        name: 'report.admins',
        users: [
          { shortid: 'uI34123' },
          { shortid: 'ZO_YvCU' }
        ],
        creationDate: '2024-10-17T15:43:56.857Z',
        modificationDate: '2025-08-01T09:28:17.612Z',
        shortid: 'rEm3gSt',
        _id: 'Zyz3yaEsuO3KqU5B',
        isAdmin: true,
        folder: { shortid: 'od2l1ml' }
      }
    ],
    index: 0
  }
};
